// src/stone/icons/Link.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Link = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12.775 2.75a6 6 0 0 1 8.484 8.485l-.012.012-3 3a6 6 0 0 1-9.048-.648 1 1 0 1 1 1.602-1.198 4 4 0 0 0 6.032.432l2.994-2.994a4 4 0 0 0-5.657-5.655L12.455 5.89a1 1 0 0 1-1.41-1.418l1.72-1.71z" }),
      /* @__PURE__ */ jsx("path", { d: "M7.9 8.373a6 6 0 0 1 6.9 2.028 1 1 0 1 1-1.6 1.198 4 4 0 0 0-6.033-.432l-2.993 2.994a4 4 0 0 0 5.655 5.655l1.704-1.703a1 1 0 1 1 1.414 1.414l-1.71 1.71-.012.012a6 6 0 0 1-8.484-8.484l.012-.012 3-3a6 6 0 0 1 2.146-1.38" })
    ]
  }
);
var Link_default = Link;

export {
  Link_default
};
